import 'lazysizes';

/**
 * Enables lazy loading for images, pictures, and background images.
 *
 * For `img` and `picture` elements, the image in `src` will first be loaded,
 * then `data-src` will get loaded when "needed".
 *
 * For background images, the image style="background-image: url('...');" will
 * first be loaded, then `data-bg` will get loaded when "needed".
 *
 * Add class `lazyload` to enable.
 */
const LazyLoading = {

    /**
     * Initialise functionality
     */
    init()
    {
    },

};

/**
 * Enable background image support
 */
document.addEventListener('lazybeforeunveil', (e) => {

    // Skip non-"background image" elements
    if (['IMG', 'SOURCE'].includes(e.target.tagName)) {
        return;
    }

    // Set background image
    const src = e.target.getAttribute('data-bg');
    if (src) {
        e.target.style.backgroundImage = `url('${src}')`;
    }

});

export default LazyLoading;